module.exports = __webpack_public_path__ + "img/img_supplier_jly@2x.c06d82a9.png";